import axios from "axios";
import { base_url } from "../../utils/baseUrl";



const getVillaBookings = async () => {

    const response = await axios.get(`${base_url}elivaas/booking`);

    return response.data;

};
const createVillaBooking = async (values) => {
    const response = await axios.post(`${base_url}elivaas/booking`, values);

    return response.data;
};

const updateVillaBooking = async (values) => {
    const id = values.id
    const response = await axios.put(
        `${base_url}elivaas/booking/${id}`,
        values,

    );

    return response.data;
};
const updateVillaBookingStatus = async (values) => {
    console.log(values, "status")
    const id = values.id
    const response = await axios.put(
        `${base_url}elivaas/booking/${id}/approve-supplier`,
        values,
        {
            headers: {
                "Authorization": `Bearer ${localStorage.getItem("token")}`
            },
        }

    );

    return response.data;
};

const getVillaBooking = async (id) => {
    const response = await axios.get(`${base_url}elivaas/booking/${id}`);
    return response.data;
};

const deleteVillaBooking = async (id) => {
    const response = await axios.delete(`${base_url}elivaas/booking/${id}`);

    return response.data;
};
const VillaBookingService = {
    getVillaBookings,
    createVillaBooking,
    getVillaBooking,
    updateVillaBooking,
    updateVillaBookingStatus,
    deleteVillaBooking,
};

export default VillaBookingService;
